import { render, staticRenderFns } from "./FilterDatatable.vue?vue&type=template&id=b96472e8"
import script from "./FilterDatatable.vue?vue&type=script&lang=js"
export * from "./FilterDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports